import { BundleTreeTypes, SectionsTreeNode } from '../types';

export const findFullNodePathToNodeByPageId = (
  pageId: string,
  tree: SectionsTreeNode[],
  path: SectionsTreeNode[] = []
): SectionsTreeNode[] | null => {
  for (const node of tree) {
    const currentPath = [...path, node];
    if (node.pageIds?.includes(pageId)) return currentPath;
    if (node.children) {
      const result = findFullNodePathToNodeByPageId(pageId, node.children, currentPath);
      if (result) return result;
    }
  }
  return null;
};

export interface ParentNodeInfoWithOriginalPath {
  provider?: { node: SectionsTreeNode | null; level: number };
  category?: { node: SectionsTreeNode | null; level: number };
  subcategory?: { node: SectionsTreeNode | null; level: number };
  cluster?: { node: SectionsTreeNode | null; level: number };
  originalPath: SectionsTreeNode[] | null;
}

export const getAllParentNodesByPageId = (pageId: string, tree: SectionsTreeNode[]): ParentNodeInfoWithOriginalPath => {
  const path = findFullNodePathToNodeByPageId(pageId, tree);
  const parentNodes: ParentNodeInfoWithOriginalPath = {
    originalPath: path
  };

  if (path && path.length > 1) {
    // The path includes the node containing the pageId itself, so we start from the parent
    for (let i = 0; i < path.length - 1; i++) {
      const currentNode = path[i];
      switch (currentNode.type) {
        case BundleTreeTypes.PROVIDER:
          parentNodes.provider = { node: currentNode, level: i };
          break;
        case BundleTreeTypes.CATEGORY:
          parentNodes.category = { node: currentNode, level: i };
          break;
        case BundleTreeTypes.SUB_CATEGORY:
          parentNodes.subcategory = { node: currentNode, level: i };
          break;
        case BundleTreeTypes.CLUSTER:
          parentNodes.cluster = { node: currentNode, level: i };
          break;
        // The node containing the pageId ('document' or other) is not included here
      }
    }
  }

  return parentNodes;
};
